import { PipesModule } from '@digipay/ng-lib-pipes';
import { Component, input } from '@angular/core';
import { IFundProfileModel } from '../../../models/fund-profile.model';
import { FormatedDate } from '../../../../../shared/pipes/formated-date.pipe';
import { BorderColorsEnum, NgxDividerComponent } from '@digipay/ngx-divider';

@Component({
  selector: 'app-fund-profile-price-card',
  standalone: true,
  imports: [PipesModule, FormatedDate, NgxDividerComponent],
  templateUrl: './fund-profile-price-card.component.html',
  styleUrl: './fund-profile-price-card.component.scss',
})
export class FundProfilePriceCardComponent {
  profile = input.required<IFundProfileModel>();
  protected readonly BorderColorsEnum = BorderColorsEnum;
}
